import React from 'react';
import FooterPageLayout from '../../components/layouts/FooterPageLayout';

const Careers = () => {
  const roles = [
    {
      title: 'Product Manager',
      type: 'Part-time',
      department: 'Product',
      location: 'Remote',
      description: 'Lead product development and help shape the future of Pebble.'
    },
    {
      title: 'UI/UX Designer',
      type: 'Part-time',
      department: 'Design',
      location: 'Remote',
      description: 'Create beautiful, intuitive experiences for our users.'
    },
    {
      title: 'Graphic Design & Social Media',
      type: 'Intern',
      department: 'Marketing',
      location: 'Remote',
      description: 'Help build our visual identity and social media presence.'
    },
    {
      title: 'Content Creation',
      type: 'Intern',
      department: 'Marketing',
      location: 'Remote',
      description: 'Create compelling photo and video content for our platforms.'
    },
    {
      title: 'IT Support',
      type: 'Part-time',
      department: 'Technology',
      location: 'Remote',
      description: 'Provide technical support and maintain our systems.'
    },
    {
      title: 'Business Development',
      type: 'Part-time',
      department: 'Business',
      location: 'Remote',
      description: 'Drive growth through partnerships and market expansion.'
    }
  ];

  return (
    <FooterPageLayout>
      <div className="max-w-6xl mx-auto px-8 py-12">
        {/* Hero Section */}
        <div className="mb-16">
          <h1 className="text-5xl font-bold mb-12 text-[#B22A2B]">
            Join us. Be you.
          </h1>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            <div className="p-6 rounded-[24px] bg-white border border-gray-100">
              <h2 className="text-2xl font-bold mb-4 text-[#B22A2B]">
                Work at Pebble
              </h2>
              <p className="text-gray-600 text-lg mb-4 leading-relaxed">
                This is where individual imaginations gather together, committing to the values that lead to great work. 
                Here, you'll do more than join something — you'll add something.
              </p>
              <div className="text-gray-800">
                <p className="text-lg italic leading-relaxed mb-2">
                  "We're not just building software. We're creating experiences that bring communities together, making every festival, market, and event an unforgettable moment."
                </p>
                <p className="text-base text-[#B22A2B]">— Matt Hughes, UI/UX Designer</p>
              </div>
            </div>

            <div className="p-6 rounded-[24px] bg-white border border-gray-100">
              <h2 className="text-2xl font-bold mb-4 text-[#B22A2B]">
                Life at Pebble
              </h2>
              <p className="text-gray-600 text-lg leading-relaxed">
                Explore a collaborative culture of inclusion, growth, and originality, supported by resources that make a difference in your life.
                At Pebble, you can unapologetically be yourself and grow and thrive.
              </p>
            </div>
          </div>

          <div className="bg-white rounded-[24px] p-8 border border-gray-100">
            <h2 className="text-2xl font-bold mb-6 text-[#B22A2B]">Our Values</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div>
                <h3 className="text-xl font-semibold mb-2 text-[#B22A2B]">Innovation</h3>
                <p className="text-gray-600">Technology is most powerful when it brings positive change to people's lives.</p>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-2 text-[#B22A2B]">Inclusion</h3>
                <p className="text-gray-600">We're committed to building an inclusive environment where everyone can thrive.</p>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-2 text-[#B22A2B]">Impact</h3>
                <p className="text-gray-600">Join us in creating solutions that make a real difference in the world.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Job Listings Section */}
        <h2 className="text-3xl font-bold mb-8 text-[#B22A2B]">Current Openings</h2>
        <div className="space-y-4">
          {roles.map((role) => (
            <div 
              key={role.title}
              className="bg-white rounded-[24px] p-6 flex justify-between items-start border border-gray-100"
            >
              <div>
                <h3 className="text-lg font-semibold mb-2 text-gray-900">
                  {role.title} <span className="font-normal">{role.type}</span>
                </h3>
                <div className="text-gray-600 text-sm mb-2">
                  {role.department} <span className="mx-3 text-gray-400">•</span> 
                  {role.location}
                </div>
                <p className="text-gray-600 text-sm">{role.description}</p>
              </div>
              <div>
                <a 
                  href={`mailto:careers@pebbletheapp.com?subject=${encodeURIComponent(role.title)} Application`}
                  className="inline-block bg-white text-black px-5 py-2 rounded-2xl text-sm font-medium border border-[#B22A2B] hover:bg-[#B22A2B] hover:text-white transition-colors duration-200"
                >
                  Apply Now
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </FooterPageLayout>
  );
};

export default Careers; 